import * as React from "react";
import {ReviewEntry} from "src/app/model/ReviewEntry";
import {KatDataTable, KatPagination} from "@amzn/katal-react";
import {useRef, useState} from "react";
import {REVIEW_EXPORT_TABLE_HEADER} from "src/app/config/TableConfig";
import {DEFAULT_PAGE_SIZE} from "src/app/constant/Constants";

interface ReviewPreviewListProps {
    reviews: ReviewEntry[];
}

const ReviewPreviewList = (props: ReviewPreviewListProps) => {
    const pageRef = useRef<any>(null);
    const columns = REVIEW_EXPORT_TABLE_HEADER;
    const total = props.reviews.length;

    const [currentPage, setCurrentPage] = useState<number>(() => {
        return 1;
    });
    const [pageSize, setPageSize] = useState<number>(DEFAULT_PAGE_SIZE);
    const [currentReviewData, setCurrentReviewData] = useState<ReviewEntry[]>(() => {
        return props.reviews.slice(0, DEFAULT_PAGE_SIZE);
    });

    const onPageChange = () => {
        const page = pageRef.current.__page;
        const start = (page-1) * pageSize;
        const end = page * pageSize > total ? total : page * pageSize;
        setCurrentReviewData(props.reviews.slice(start, end));
        setCurrentPage(page);
    }

    const onPagesizeChange = () => {
        const itemsPerPage = pageRef.current.__itemsPerPage;
        const end = 1 * itemsPerPage > total ? total : 1 * itemsPerPage;
        const start = end - itemsPerPage >= 0 ? end - itemsPerPage : 0;
        setCurrentReviewData(props.reviews.slice(start, end));
        setCurrentPage(1);
        setPageSize(itemsPerPage);
    }

    return (
        <div>
            <div className="kat default-margin" id='data-list'
                 style={{overflow: "scroll", maxHeight: "720px", position: "relative"}}>
                <KatDataTable columns={columns} rowData={currentReviewData} titleLabel={'Data Preview'}
                              className='data-table' data-testid='review-table'></KatDataTable>
            </div>
            <div className='pagination-footer-style default-margin'>
                <KatPagination totalItems={props.reviews.length} page={currentPage} itemsPerPage={pageSize}
                               onPageChanged={onPageChange} onItemsPerPageChange={onPagesizeChange} ref={pageRef}
                               className='pagination' variant={'footer'} data-testid='review-pagination'>
                </KatPagination>
            </div>
        </div>
    )
}

export default ReviewPreviewList;